import { Inference } from "../../types/inferences";

// In composite mode, the id used for validation/update calls is the composite_id;
// otherwise it's the inference's own id.
export function getInferenceId(
  selectedInference: Inference,
  compositeMode: boolean
): number {
  if (compositeMode) {
    const compositeId = selectedInference.properties.composite_id;
    if (compositeId === undefined) {
      // eslint-disable-next-line no-console
      console.error("Composite mode enabled but composite_id is undefined");
      return 0;
    }
    return compositeId;
  }
  const inferenceId = selectedInference.properties.id;
  if (inferenceId === undefined) {
    // eslint-disable-next-line no-console
    console.error("Inference id is undefined");
    return 0;
  }
  return inferenceId;
}

export function getCompositeIds(
  selectedInference: Inference,
  compositeMode: boolean
): number[] | undefined {
  if (compositeMode && selectedInference.properties.ids) {
    return selectedInference.properties.ids;
  }
  return undefined;
}
